import NavItem from "@/ui/atoms/NavItem"
import Typography from "@/ui/atoms/Typography"
import { scrollToElement } from "@/ui/utils/scroll"
import { classNames } from "@punks/ui-core"
import { ReactNode } from "react"

export interface MenuNavItemProps {
  anchor?: string
  link?: string
  label: ReactNode
  className?: string
  onClick?: () => void
  active?: boolean
}

const MenuNavItem = ({
  link,
  anchor,
  label,
  className,
  onClick,
  active,
}: MenuNavItemProps) => {
  return (
    <NavItem
      link={link}
      className={className}
      onClick={
        anchor
          ? () => {
              scrollToElement(anchor)
              onClick?.()
            }
          : undefined
      }
    >
      <Typography
        variant={"subtitle2"}
        weight={"medium"}
        className={classNames({
          "border-b-[2px] border-text": active,
        })}
      >
        {label}
      </Typography>
    </NavItem>
  )
}

export default MenuNavItem
